import Modal from "react-bootstrap/Modal";

export const ViewComplicationDetailsModal = ({
  isOpen,
  setIsOpen,
  complicationDetails,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Procedimientos con complicaciones</h5>
      </Modal.Header>
      <Modal.Body>
        <div
          className="table-responsive shadow rounded"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          <table className="table table-center bg-white mb-0">
            <thead>
              <tr>
                <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                  #
                </th>
                <th className="border-bottom p-3">Nombre del paciente</th>
                <th className="border-bottom p-3">Procedimiento</th>
                <th className="border-bottom p-3">Complicaciones</th>
              </tr>
            </thead>
            <tbody>
              {complicationDetails.map((complicationDetail, index) => (
                <tr key={index}>
                  <th className="p-3">{index + 1}</th>
                  <td className="py-3">{complicationDetail.patientName}</td>
                  <td className="py-3">{complicationDetail.procedureDone}</td>
                  <td className="py-3">
                    {complicationDetail.complicationText}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};
